<script>

  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        menuOpen: state => state.menuOpen
      }),
      iconName () {
        return this.menuOpen ? 'cross' : 'menu'
      }
    },
    methods: {
      handleClick () {
        this.$store.commit('SET_MENU', !this.menuOpen)
      }
    }
  }
</script>

<template>
  <button
    class="flex items-center justify-center hamburger"
    aria-label="Menu openen"
    @click="handleClick"
  >
    <q-icon
      :name="iconName"
      class="w-7 h-7"
    />
  </button>
</template>

<style lang="scss">

  .hamburger {
    margin-left: 30px !important;
    &:focus {
      @apply outline-none;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }

</style>
